<div class="intervention-view-wrapper">
  <!-- Loading state -->
  <div *ngIf="loading" class="loading-container">
    <p-progressSpinner></p-progressSpinner>
    <span>Chargement des données de l'intervention...</span>
  </div>

  <!-- Error state -->
  <div *ngIf="!loading && error" class="error-container">
    <i class="pi pi-exclamation-triangle text-3xl text-yellow-500 mb-3"></i>
    <h3>Une erreur est survenue</h3>
    <p>{{ error }}</p>
    <button
      pButton
      label="Réessayer"
      icon="pi pi-refresh"
      (click)="refresh()"
      class="mt-3"
    ></button>
  </div>

  <!-- Intervention content when loaded -->
  <div
    *ngIf="!loading && !error && intervention"
    class="intervention-container"
  >
    <!-- Fixed header section -->
    <div class="intervention-header-section">
      <app-intervention-header
        [intervention]="intervention"
      ></app-intervention-header>

      <p-divider></p-divider>

      <!-- Actions row -->
      <div class="action-buttons">
        <!-- Actions de statut -->
        <div class="action-group">
          <p-button
            *ngIf="isWaitingConfirmation"
            icon="pi pi-check"
            label="Confirmer l'intervention"
            (onClick)="confirmIntervention()"
            [loading]="confirmLoading"
            styleClass="p-button-success"
          >
          </p-button>

          <p-button
            *ngIf="isConfirmed"
            icon="pi pi-clock"
            label="Marquer comme non confirmée"
            (onClick)="markAsWaitingConfirmation()"
            [loading]="waitingConfirmationLoading"
            styleClass="p-button-warning"
          >
          </p-button>

          <p-button
            *ngIf="isConfirmed"
            icon="pi pi-calendar"
            label="Décaler"
            (onClick)="openShiftModal()"
            styleClass="p-button-help"
          >
          </p-button>

          <p-button
            *ngIf="canBeUnprogrammed"
            icon="pi pi-calendar-minus"
            label="Déprogrammer"
            (onClick)="openUnprogrammingModal()"
            styleClass="p-button-danger"
          >
          </p-button>

          <p-button
            icon="pi pi-calendar-plus"
            label="Replanifier"
            (onClick)="rescheduleIntervention()"
            styleClass="p-button-info"
          >
          </p-button>

          <p-button
            icon="pi pi-envelope"
            label="Envoyer un mail"
            (onClick)="openSendMailModal()"
            styleClass="p-button-secondary"
          >
          </p-button>
        </div>

        <!-- Actions de navigation -->
        <div class="action-group">
          <p-button
            icon="pi pi-sync"
            (onClick)="refresh()"
            styleClass="p-button-outlined"
            pTooltip="Actualiser"
            tooltipPosition="bottom"
          ></p-button>
          <p-button
            icon="pi pi-file"
            (onClick)="navigateToAffair()"
            styleClass="p-button-outlined"
            pTooltip="Voir l'affaire"
            tooltipPosition="bottom"
          ></p-button>
          <p-button
            icon="pi pi-external-link"
            (onClick)="openOnEros()"
            styleClass="p-button-outlined"
            pTooltip="Ouvrir dans Éros"
            tooltipPosition="bottom"
          ></p-button>
        </div>
      </div>
    </div>

    <!-- Scrollable content area -->
    <div class="intervention-scrollable-content">
      <div class="content-grid">
        <!-- Left column - Details -->
        <div class="grid-section details-column">
          <app-intervention-details
            [intervention]="intervention"
          ></app-intervention-details>
        </div>

        <!-- Middle column - People and Products -->
        <div class="grid-section info-column">
          <!-- People section with 2 columns -->
          <div class="people-row">
            <div class="people-box">
              <app-intervention-technicians
                [technicians]="intervention.usersTechnicians"
                [assistant]="intervention.userAssistant"
              >
              </app-intervention-technicians>
            </div>

            <div class="people-box">
              <app-intervention-contacts
                [contacts]="intervention.contacts"
                [worksSupervisor]="intervention.worksSupervisor"
                [affairsContacts]="intervention.affairsContacts"
              >
              </app-intervention-contacts>
            </div>
          </div>

          <!-- Products section -->
          <div class="products-section">
            <app-intervention-products
              [products]="intervention.affairProducts"
            ></app-intervention-products>
          </div>
        </div>

        <!-- Right column - Mails -->
        <div class="grid-section mails-column">
          <app-affair-mails
            [mails]="mails"
            [mailsLoading]="mailsLoading"
          ></app-affair-mails>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty state -->
  <div *ngIf="!loading && !error && !intervention" class="error-container">
    <i class="pi pi-exclamation-circle text-3xl text-blue-500 mb-3"></i>
    <h3>Intervention non trouvée</h3>
    <p>L'intervention demandée n'existe pas ou n'est pas accessible.</p>
    <button
      pButton
      label="Retour"
      icon="pi pi-arrow-left"
      (click)="router.navigate(['/interventions-incoming'])"
      class="mt-3"
    ></button>
  </div>
</div>

<!-- Toast pour les notifications -->
<p-toast></p-toast>

<!-- Modal de décalage d'intervention -->
<app-shift-modal
  [(visible)]="showShiftModal"
  [selectedEvent]="shiftSelectedEvent"
  [shiftOrigins]="shiftOrigins"
  [loadingShiftOrigins]="shiftModalLoading"
  [submitting]="shiftModalLoading"
  [allTechnicians]="allTechnicians"
  (onSubmit)="handleShiftSubmit($event)"
></app-shift-modal>

<!-- Ajouter la modale de déprogrammation -->
<app-unprogramming-modal
  [(visible)]="showUnprogrammingModal"
  [selectedEvent]="unprogrammingSelectedEvent"
  [shiftOrigins]="shiftOrigins"
  [submitting]="unprogrammingLoading"
  [loadingShiftOrigins]="shiftModalLoading"
  (onSubmit)="handleUnprogrammingSubmit($event)"
></app-unprogramming-modal>

<!-- Modale d'envoi de mail -->
<app-send-mail-modal
  [(visible)]="showSendMailModal"
  [interventionId]="intervention?.id ?? null"
  [affairRef]="intervention?.affair?.mlRef ?? null"
  [erpSource]="currentErpSource"
  (onSent)="onMailSent()"
></app-send-mail-modal>
